<script>
  export default {
    name: 'MapSuggestions',
    props: {
      suggestions: {
        type: Array,
        required: true
      },
      showListCount: {
        type: Number,
        required: true
      },
      handleCenterClick: {
        type: Function,
        required: true
      },
    },
  }
</script>


<template>
  <ul class="nyk-pi-map__map-section__suggestions__list">
    <template v-for="(info, index) in suggestions" :key="index">
        <template v-if="index < showListCount">
            <li class="nyk-pi-map__map-section__suggestions__list__item">
                <div class="nyk-pi-map__map-section__suggestions__list__item__link" v-on:click="handleCenterClick(info)">
                    <div class="nyk-pi-map__map-section__suggestions__list__item__link__card">
                        <div class="nyk-pi-map__map-section__suggestions__list__item__link__card__header">
                            <h3 class="nyk-pi-map__map-section__suggestions__list__item__link__card__header__title">
                                {{ info.name }}
                            </h3>
                            <p class="nyk-pi-map__map-section__suggestions__list__item__link__card__header__address">
                              {{ info.branchName }}
                            </p>
                            <p class="nyk-pi-map__map-section__suggestions__list__item__link__card__header__address">
                                {{ info.address }}
                            </p>
                            <p class="nyk-pi-map__map-section__suggestions__list__item__link__card__header__postal-code">
                                {{ info.zipcode }} {{ info.city }}
                            </p>
                        </div>
                    </div>

                    <div class="nyk-pi-map__map-section__suggestions__list__item__arrow">
                        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12">
                            <path
                                fill="#07094A"
                                d="M0 5.393v1.231h11.37l-3.898 4.243.67.633L14 5.991 8.142.5l-.67.633 3.898 4.26H0Z" />
                        </svg>
                    </div>
                  </div>
            </li>
        </template>
    </template>
  </ul>
</template>